<script lang="ts">
  import Bank from "~icons/ph/bank-light";
  import CreditCard from "~icons/ph/credit-card-light";
  import FooterButtons from "../../components/workflow/FooterButtons.svelte";
  import CloseButton from "../../components/CloseButton.svelte";
</script>

<h2 class="ui-title">How to find your finance company name</h2>

<p class="mb-6">Since we need the name of your vehicle finance company to continue your claim, try the options below to find it.</p>

<div class="grid grid-cols-[78px_auto] gap-x-4 gap-y-6">
  <div class="flex items-center justify-center aspect-1 rounded-lg bg-gradient-to-tl from-sky-500/60 to-sky-100/60">
    <Bank class="h-11 w-11 text-sky-700" />
  </div>
  <div>
    <div class="font-bold mb-2">Check your bank to see who monthly payments were sent to</div>
    <p class="text-gray-600 text-sm">
      Look through your bank statements from when you were paying for the vehicle. The finance company name usually
      appears next to the monthly payment. You can download statements from your banking app or online banking.
    </p>
  </div>
  <div class="flex items-center justify-center aspect-1 rounded-lg bg-gradient-to-tl from-emerald-500/60 to-emerald-100/60">
    <CreditCard class="h-11 w-11 text-emerald-700" />
  </div>
  <div>
    <div class="font-bold mb-2">Check your credit report for free</div>
    <p class="text-gray-600 text-sm">
      You can access your credit report online for free through UK credit reference agencies.
    </p>
  </div>
</div>

<FooterButtons>
  <CloseButton class="btn-primary" />
</FooterButtons>
